// this is a light-weight build without the scrolling module
module.exports = require("./src/index.js");